export default __webpack_public_path__ + "static/media/klubb-logo.55e4574e.webp";